const areaMembros = angular.module('areaMembros', [])

areaMembros.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.areaMembros',
            url: '/areaMembros',
            params: { showGlobalLoading: { dynamic: true, value: false }},
            component: 'areaMembros.areaMembrosComponent'
        },
        {
            name: 'admin.editarAreaMembros',
            url: '/areaMembros/:idAreaMembros',
            params: { showGlobalLoading: { dynamic: true, value: false }, idAreaMembros: "6zIojRWp7z24vWsi74ho" },
            component: 'areaMembros.areaMembrosDetalheComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);